import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { CheckoutExtensionUI } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { capitalize } from '@utils/string-utils';
import { SubscriptionSelectorType, TRANSPARENT_APPEARANCE } from '../../../../config';
import { USE_FIRST_AVAILABLE_PLAN_TOOLTIP } from '../../../../../../shared/tooltip-texts';

@Component({
  selector: 'cart-control-subscription-selector',
  templateUrl: './cart-control-subscription-selector.component.html',
  styleUrl: './cart-control-subscription-selector.component.scss',
  standalone: false,
})
export class CartControlSubscriptionSelectorComponent {
  @Input({ required: true }) typeControl: FormControl<SubscriptionSelectorType>;
  @Input({ required: true }) upgradeButtonLabelControl: FormControl<string>;
  @Input({ required: true }) upgradeButtonAppearanceControl: FormControl<string>;
  @Input({ required: true }) upgradeButtonTextColorControl: FormControl<string>;
  @Input() upgradeButtonLabelInvalid = false;

  readonly SubscriptionSelectorType = SubscriptionSelectorType;
  readonly TRANSPARENT_APPEARANCE = TRANSPARENT_APPEARANCE;
  readonly upgradeTooltip = USE_FIRST_AVAILABLE_PLAN_TOOLTIP;
  readonly UpgradeAppearances = [
    TRANSPARENT_APPEARANCE,
    CheckoutExtensionUI.Appearance.BASE,
    CheckoutExtensionUI.Appearance.MONOCHROME,
    CheckoutExtensionUI.Appearance.CRITICAL,
  ];
  readonly TextColorAppearances = Object.values(CheckoutExtensionUI.Appearance);
  readonly upwardOverlayPositions: ConnectedPosition[] = [
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'bottom',
    },
  ];

  appearanceToDisplayText = (value: string) => capitalize(value);
}
